import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@domestika-dev/prudencio/dist/atoms/Layout";
import { LiveSetupCredentialsCards } from "./LiveSetupCredentialsCards";
import { LiveSetupHeader } from "./LiveSetupHeader";
import { LiveSetupStepInfo } from "./LiveSetupStepInfo";
import { LiveSetupSubtitle } from "./LiveSetupSubtitle";
import { LiveSetupTitle } from "./LiveSetupTitle";
import When from "../../../../common/When";
import { LiveSetupFooter } from "./LiveSetupFooter";

export const LiveSetupCredentialsStep = ({
  enableNavigation,
  liveChannel,
  onNextStep,
  onClose,
}) => {
  return (
    <>
      <LiveSetupHeader showPreviousStep={false} onClose={onClose} />
      <Grid
        gridRowGap={[4, 4, 4]}
        style={{
          overflowY: "auto",
          overflowX: "hidden",
          marginTop: "40px",
          marginBottom: enableNavigation ? "72px" : "0",
          marginRight: "-16px",
          paddingRight: "16px",
        }}
      >
        <LiveSetupTitle title="live_sessions.streamlabs_setup.title" />
        <When condition={enableNavigation}>
          {() => <LiveSetupStepInfo currentStep={1} stepsCount={2} />}
        </When>
        <LiveSetupSubtitle subtitle="live_sessions.streamlabs_setup.subtitle" />
        <LiveSetupCredentialsCards liveChannel={liveChannel} />
      </Grid>
      <LiveSetupFooter
        enableNavigation={enableNavigation}
        nextButtonText="live_sessions.streamlabs_setup.next_button"
        onNextStep={onNextStep}
      />
    </>
  );
};

LiveSetupCredentialsStep.propTypes = {
  enableNavigation: PropTypes.bool,
  liveChannel: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    streamKeyValue: PropTypes.string,
    ingestEndpoint: PropTypes.string,
  }),
  onNextStep: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

LiveSetupCredentialsStep.defaultProps = {
  enableNavigation: false,
  liveChannel: {},
};

export default LiveSetupCredentialsStep;
